import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { cn } from "@/lib/utils";

export function StatCard({ label, value, icon: Icon, hint, trend, trendDir = "up", mock = false, className }) {
  return (
    <Card
      data-testid="stat-card"
      className={cn(
        "group relative flex flex-col gap-3 self-start overflow-hidden rounded-xl border-border/70 p-5 transition-all duration-200 hover:border-primary/30 hover:shadow-[0_4px_24px_-8px_rgba(0,0,0,0.10)] dark:border-border/50 dark:hover:border-primary/50 dark:hover:shadow-[0_4px_28px_-8px_hsl(var(--primary)/0.35)]",
        className
      )}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{label}</span>
        {Icon && (
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-muted text-muted-foreground transition-colors group-hover:bg-primary/10 group-hover:text-primary dark:bg-primary/15 dark:text-primary dark:ring-1 dark:ring-primary/25">
            <Icon className="h-4 w-4" strokeWidth={1.75} />
          </span>
        )}
      </div>
      <div className="flex items-end gap-2">
        <span className="font-display text-[28px] font-bold leading-none tracking-tight tabular-nums text-foreground">{value}</span>
        {mock && (
          <Badge variant="outline" className="mb-1 text-[9px] uppercase tracking-wider text-muted-foreground">
            Mock
          </Badge>
        )}
      </div>
      <div className="flex items-center gap-2">
        {trend && (
          <span
            className={cn(
              "inline-flex items-center gap-0.5 text-xs font-semibold tabular-nums",
              trendDir === "down" ? "text-rose-500" : "text-emerald-500"
            )}
          >
            {trendDir === "down" ? <ArrowDownRight className="h-3.5 w-3.5" /> : <ArrowUpRight className="h-3.5 w-3.5" />}
            {trend}
          </span>
        )}
        {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
      </div>
    </Card>
  );
}
